export default {
  splitByCharacter (el) {
    if (!el) { return false }
    let headingSplit = el.innerHTML.split(' ')
    el.innerHTML = ''
    let characters = []
    let linePos = 0
    let lines = []
    let currentLine = false
    headingSplit.forEach(character => {
      // Create new span element to contain character
      const characterEl = document.createElement('span')
      characterEl.classList.add('character')
      // Add character to new element
      character = document.createTextNode(character + ' ')
      characterEl.appendChild(character)
      // Add to DOM
      el.appendChild(characterEl)

      const linePosition = Math.floor(characterEl.getBoundingClientRect().top)

      if (linePos !== linePosition || !linePos) {
        linePos = linePosition
        var newEl = document.createElement('span')
        newEl.classList.add('line')
        lines.push(newEl)
        currentLine = newEl
      }

      var lastEl = characterEl.cloneNode(true)

      currentLine.appendChild(lastEl)
      characters.push(lastEl)
    })
    el.innerHTML = ''
    lines.forEach(line => {
      el.appendChild(line)
    })
    return characters
  },

  getPossibleDimensions (newContent, el) {
    var elPrime = el.cloneNode(true)
    elPrime.style.visibility = 'hidden'
    elPrime.style.position = 'absolute'
    elPrime.innerHTML = newContent
    el.parentElement.appendChild(elPrime)
    var height = elPrime.offsetHeight
    var width = elPrime.offsetWidth
    el.parentElement.removeChild(elPrime)
    return {
      width,
      height
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/custom-modules/text-effects/text-effects.js